import * as MetaSftpTypes from './metaSftp.types';
import { IInitialMetaState, TSftpUserItem } from 'interfaces/meta.interface';

export type TMetaSftpsDispatchReducer =
  | {
      type: typeof MetaSftpTypes.SET_SFTP_CONNECTION_SELECTED;
      payload: string | null;
    }
  | {
      type: typeof MetaSftpTypes.DELETE_SFTP_CONNECTION;
      payload: string;
    }
  | {
      type: typeof MetaSftpTypes.SET_IS_LOADING_DELETE_SFPT_CONNECTIONS;
      payload: {
        loading: boolean;
        user_name: string;
      };
    }
  | {
      type: typeof MetaSftpTypes.ADD_NEW_CONNECTION;
      payload: TSftpUserItem;
    }
  | {
      type: typeof MetaSftpTypes.SET_IS_LOADING_CREATE_SFPT_CONNECTIONS;
      payload: boolean;
    }
  | {
      type: typeof MetaSftpTypes.UPDATE_CONNECTION;
      payload: TSftpUserItem;
    }
  | {
      type: typeof MetaSftpTypes.SET_IS_LOADING_UPDATE_SFPT_CONNECTIONS;
      payload: {
        loading: boolean;
        connectionId: string | null;
      };
    };

export function handleSftp(state: IInitialMetaState, action: TMetaSftpsDispatchReducer) {
  const { type, payload } = action;

  switch (type) {
    case MetaSftpTypes.DELETE_SFTP_CONNECTION: {
      const deleteSftpConnection: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          connections: state.sftp.connections.filter((item) => item.name !== payload),
        },
      };
      return deleteSftpConnection;
    }

    case MetaSftpTypes.SET_IS_LOADING_DELETE_SFPT_CONNECTIONS: {
      const setIsLoadingRemoveSftpConnection: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          isLoadingRemoveSftpConnection: {
            loading: payload.loading,
            user_name: payload.user_name,
          },
        },
      };
      return setIsLoadingRemoveSftpConnection;
    }

    case MetaSftpTypes.ADD_NEW_CONNECTION:
      const addNewSftpConnection: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          connections: [payload, ...state.sftp.connections],
        },
      };
      return addNewSftpConnection;

    case MetaSftpTypes.SET_IS_LOADING_CREATE_SFPT_CONNECTIONS: {
      const setIsLoadingCreateSftpConection: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          isLoadingCreateSftpConnection: payload,
        },
      };
      return setIsLoadingCreateSftpConection;
    }

    case MetaSftpTypes.UPDATE_CONNECTION: {
      const updateSftpConnection: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          connections: state.sftp.connections.map((item) =>
            item.id === payload.id
              ? {
                  ...item,
                  ...payload,
                  period: Number(payload.period),
                }
              : item
          ),
        },
      };
      return updateSftpConnection;
    }

    case MetaSftpTypes.SET_IS_LOADING_UPDATE_SFPT_CONNECTIONS: {
      const setIsLoadingUpdateSftpConnection: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          isLoadingUpdateSftpConnection: {
            loading: payload.loading,
            connectionId: payload.connectionId,
          },
        },
      };
      return setIsLoadingUpdateSftpConnection;
    }

    case MetaSftpTypes.SET_SFTP_CONNECTION_SELECTED: {
      const setSftpConnectionSelected: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          connectionSelected:
            state.sftp.connections.find((item) => item.id === payload) || null,
        },
      };
      return setSftpConnectionSelected;
    }

    default:
      return state;
  }
}
